<span [pTooltip]="disabledReason() ?? ''" tooltipPosition="left">
    <p-button
        label="AI"
        [icon]="aiIcon"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="disabled() || !hasInput()"
        (click)="open()"
    />
</span>

<p-dialog
    [header]="
        mode() === 'refine'
            ? 'AI — rewrite SEO description'
            : 'AI — SEO description'
    "
    [visible]="visible()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '46rem' }"
    [breakpoints]="{ '1024px': '95vw' }"
    [modal]="true"
    [closable]="!loading()"
    [draggable]="false"
>
    <div
        class="flex flex-col gap-4"
        (keydown.control.enter)="run()"
        (keydown.meta.enter)="run()"
    >
        <!-- refine: existing text + instruction -->
        @if (mode() === 'refine') {
        <div>
            <div class="text-xs font-medium text-muted-color mb-1">
                Current text
            </div>
            <div
                class="px-3 py-2 rounded border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800 text-sm whitespace-pre-wrap max-h-32 overflow-auto"
            >
                {{ text() }}
            </div>
        </div>

        <div>
            <label for="ai-seo-instruction" class="block font-medium mb-1"
                >Instruction</label
            >
            <input
                pInputText
                id="ai-seo-instruction"
                class="w-full"
                placeholder="example: make it punchier, keep under 160 chars"
                [ngModel]="instruction()"
                (ngModelChange)="instruction.set($event ?? '')"
            />
            <small class="text-muted-color">
                @if (maxLength()) { Result is capped at {{ maxLength() }}
                characters. } Press <kbd>Ctrl/⌘ + Enter</kbd> to run.
            </small>
        </div>

        <div>
            <p-button
                label="Rewrite"
                [icon]="aiIcon"
                [loading]="loading()"
                [disabled]="!instruction().trim()"
                (click)="run()"
            />
        </div>
        } @else {
        <!-- suggest: generated from brand -->
        <div class="flex items-center justify-between gap-2">
            <small class="text-muted-color">
                The field is empty — generating options from
                <b>{{ brandName() }}</b>@if (vertical()) {, the
                <b>{{ vertical() }}</b> vertical}@if (style()) {, and the pasted
                template style}.
            </small>
            <p-button
                label="Regenerate"
                icon="pi pi-refresh"
                severity="secondary"
                outlined
                size="small"
                [loading]="loading()"
                (click)="run()"
            />
        </div>
        } @if (loading()) {
        <div class="flex items-center justify-center py-8">
            <p-progress-spinner
                styleClass="w-10 h-10"
                strokeWidth="4"
                ariaLabel="Working"
            />
        </div>
        } @if (error(); as e) {
        <p-message
            severity="error"
            icon="pi pi-times-circle"
            styleClass="w-full"
        >
            <span class="text-sm">{{ e }}</span>
        </p-message>
        } @if (candidates().length > 0) {
        <div class="flex flex-col gap-2">
            <div class="text-xs font-medium text-muted-color">
                Pick a version to apply
            </div>
            @for (c of candidates(); track c.text) {
            <div
                class="px-3 py-2 rounded border border-surface-200 dark:border-surface-700 flex items-start justify-between gap-3"
                [class.border-primary]="c.primary"
            >
                <div class="flex flex-col gap-1 min-w-0">
                    @if (c.primary) {
                    <span class="text-xs font-medium text-primary"
                        >Recommended</span
                    >
                    }
                    <span class="text-sm whitespace-pre-wrap break-words"
                        >{{ c.text }}</span
                    >
                </div>
                <p-button
                    label="Use"
                    icon="pi pi-check"
                    size="small"
                    [outlined]="!c.primary"
                    (click)="use(c.text)"
                />
            </div>
            }
        </div>
        }
    </div>
</p-dialog>
